var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoiceFeaturesIcon = function SvgVoiceFeaturesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.888 22.5a3.6 3.6 0 0 1-1.185-.195 23.85 23.85 0 0 1-15-15 3.75 3.75 0 0 1 .9-3.818l1.312-1.335a2.31 2.31 0 0 1 3.18 0L9.533 4.59a2.25 2.25 0 0 1 .48 2.482l-1.065 2.49a9.28 9.28 0 0 0 5.49 5.49l2.49-1.064a2.25 2.25 0 0 1 2.482.48l2.438 2.437a2.25 2.25 0 0 1 0 3.18l-1.328 1.328a3.75 3.75 0 0 1-2.632 1.087M5.505 3a.75.75 0 0 0-.532.225L3.645 4.537a2.25 2.25 0 0 0-.54 2.288 22.37 22.37 0 0 0 14.07 14.07 2.25 2.25 0 0 0 2.325-.54l1.328-1.328a.75.75 0 0 0 0-1.065l-2.483-2.437a.75.75 0 0 0-.825-.158l-2.752 1.178a.75.75 0 0 1-.533 0A10.82 10.82 0 0 1 7.433 9.75a.75.75 0 0 1 0-.533l1.177-2.76a.75.75 0 0 0-.157-.825L6.038 3.217A.75.75 0 0 0 5.505 3",
    clipRule: "evenodd"
  })));
};
export default SvgVoiceFeaturesIcon;